import { apiClient, ApiError, getAuthToken } from './client';
import { mapOrganisationEntitlementsDto } from './dtoMappers';
import { getErrorMessage } from './errors';
import type { OrganisationEntitlementsDto } from '@flowqa/shared';

const toApiError = (err: unknown): ApiError =>
  err instanceof ApiError ? err : new ApiError(getErrorMessage(err));

const ensureToken = (tokenOverride?: string | null): string => {
  const token = tokenOverride ?? getAuthToken();
  if (!token) {
    throw new ApiError('Not authenticated');
  }
  return token;
};

export const getOrganisationEntitlements = async (
  organisationId: string,
  tokenOverride?: string | null,
): Promise<OrganisationEntitlementsDto> => {
  const token = ensureToken(tokenOverride);
  try {
    const result = await apiClient.get<OrganisationEntitlementsDto>(
      `organisations/${organisationId}/entitlements`,
      { retries: 1, token },
    );
    return mapOrganisationEntitlementsDto(result);
  } catch (err) {
    throw toApiError(err);
  }
};
